import {AxiosError} from 'axios';
import {GET_NOTIFICATION_FEATURE_URL} from '../../constants/apiUrls';
import {GET_NOTIFICATION_FEATURE_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface DropdownOption {
  code: string;
  description: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: DropdownOption[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNotificationFeature = ({onSuccess, onError}: Input = {}) => {
  const getNotificationFeature = async () => {
    const res = await axiosClient.get<DropdownOption[]>(GET_NOTIFICATION_FEATURE_URL);
    return res.data;
  };

  return useCustomQuery(GET_NOTIFICATION_FEATURE_QUERY_KEY, getNotificationFeature, {
    onSuccess,
    onError,
  });
};
